import { TranscriptInconsistencyLevel, TranscriptInconsistencyStatus } from '../../../../api/types/backend-dto-types';

export const getInconsistencyLevelColor = (level: TranscriptInconsistencyLevel | string): string => {
  const levelStr = String(level);

  switch (levelStr) {
    case TranscriptInconsistencyLevel.Severe:
      return 'border-red-500 bg-red-50';
    case TranscriptInconsistencyLevel.Minor:
      return 'border-yellow-500 bg-yellow-50';
    default:
      return 'border-gray-500 bg-gray-50';
  }
};

export const getInconsistencyLeftBorderColor = (level: TranscriptInconsistencyLevel | string): string => {
  const levelStr = String(level);

  switch (levelStr) {
    case TranscriptInconsistencyLevel.Severe:
      return 'border-red-500';
    case TranscriptInconsistencyLevel.Minor:
      return 'border-yellow-500';
    default:
      return 'border-gray-500';
  }
};

export const getInconsistencyStatusStyles = (status: TranscriptInconsistencyStatus | string): string => {
  const statusStr = String(status);

  switch (statusStr) {
    case TranscriptInconsistencyStatus.Complete:
      return ''; // No additional styling for complete/active inconsistencies
    case TranscriptInconsistencyStatus.Reprocessing:
      return 'bg-blue-50 border-blue-200 animate-pulse'; // Light blue background with pulse animation
    case TranscriptInconsistencyStatus.Invalidated:
      return 'opacity-60 border-dashed bg-gray-50'; // Faded appearance with dashed border
    case TranscriptInconsistencyStatus.Dismissed:
      return 'opacity-40 grayscale'; // Very faded and grayscale
    default:
      return '';
  }
};

export const getInconsistencyStatusLabel = (status: TranscriptInconsistencyStatus | string): string => {
  const statusStr = String(status);

  switch (statusStr) {
    case TranscriptInconsistencyStatus.Complete:
      return 'Active';
    case TranscriptInconsistencyStatus.Reprocessing:
      return 'Reprocessing';
    case TranscriptInconsistencyStatus.Invalidated:
      return 'Invalidated';
    case TranscriptInconsistencyStatus.Dismissed:
      return 'Dismissed';
    default:
      return 'Unknown';
  }
};

export const getInconsistencyStatusBadgeColor = (status: TranscriptInconsistencyStatus | string): string => {
  const statusStr = String(status);

  switch (statusStr) {
    case TranscriptInconsistencyStatus.Complete:
      return 'bg-green-100 text-green-800'; // Green for active/complete
    case TranscriptInconsistencyStatus.Reprocessing:
      return 'bg-blue-100 text-blue-800'; // Blue for reprocessing
    case TranscriptInconsistencyStatus.Invalidated:
      return 'bg-orange-100 text-orange-800'; // Orange for invalidated
    case TranscriptInconsistencyStatus.Dismissed:
      return 'bg-gray-100 text-gray-600'; // Gray for dismissed
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export const getInconsistencyDotColor = (color?: string) => {
  if (!color) return 'bg-gray-400';
  const colorMap: { [key: string]: string } = {
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    purple: 'bg-purple-500',
    orange: 'bg-orange-500',
    pink: 'bg-pink-500',
    indigo: 'bg-indigo-500',
    amber: 'bg-amber-500',
    gray: 'bg-gray-500',
    slate: 'bg-slate-500',
    zinc: 'bg-zinc-500',
  };
  return colorMap[color] || 'bg-gray-400';
};

export const getInconsistencyTextColor = (color?: string) => {
  if (!color) return 'text-gray-700';
  const colorMap: { [key: string]: string } = {
    blue: 'text-blue-700',
    green: 'text-green-700',
    purple: 'text-purple-700',
    orange: 'text-orange-700',
    pink: 'text-pink-700',
    indigo: 'text-indigo-700',
    amber: 'text-amber-700',
    gray: 'text-gray-700',
    slate: 'text-slate-700',
    zinc: 'text-zinc-700',
  };
  return colorMap[color] || 'text-gray-700';
};
